<template>
  <div class="cursor-pointer d-flex align-items-center" @click="onBookmark">
    <svg v-if="isBookmark" class="bookmark-red-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path d="M416,480,256,357.41,96,480V32H416Z" fill="red" />
    </svg>
    <span v-else class="cil-bookmark d-block bookmark-icon" />
  </div>
</template>
  
<script>
export default {
  name: 'Bookmark',
  props: {
    isBookmark: {
      type: Boolean,
      default: false,
    },
    onBookmark: {
      type: Function,
      default: () => {},
    },
  },
}
</script>

<style scoped>
.bookmark-icon {
  font-size: 12px;
}
.bookmark-red-icon {
  color: red;
  width: 12px;
  height: 12px;
}
</style>
